"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var UserManagerClient_1 = __importDefault(require("./UserManagerClient"));
var client = null;
var authHelper = {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    getClient: function (settings) {
        if (!client || settings) {
            client = new UserManagerClient_1.default(settings);
        }
        return client;
    },
    getClientId: function () {
        if (client && client.settings) {
            return client.settings.client_id;
        }
        return null;
    },
    getAccessToken: function (withType) {
        if (withType === void 0) { withType = true; }
        if (client && client.user) {
            if (withType) {
                return client.user.token_type + " " + client.user.access_token;
            }
            return client.user.access_token;
        }
        return null;
    },
    getUser: function () {
        if (client) {
            return client.user;
        }
        return null;
    },
};
exports.default = authHelper;
//# sourceMappingURL=authHelper.js.map